import * as React from 'react'
import { cn } from '../../lib/cn'

/**
 * PageHeader — appears at the top of every admin route.
 * Composition: Breadcrumb (slot) + Title + Description + Actions.
 */
export interface PageHeaderProps extends Omit<React.HTMLAttributes<HTMLElement>, 'title'> {
  title: React.ReactNode
  description?: React.ReactNode
  breadcrumb?: React.ReactNode
  actions?: React.ReactNode
  tabs?: React.ReactNode
}

export const PageHeader = React.forwardRef<HTMLElement, PageHeaderProps>(
  ({ className, title, description, breadcrumb, actions, tabs, ...props }, ref) => (
    <header
      ref={ref}
      className={cn('flex flex-col gap-3 pb-4 border-b border-ia-border', className)}
      {...props}
    >
      {breadcrumb && <div className="text-caption text-ia-text-tertiary">{breadcrumb}</div>}
      <div className="flex items-start justify-between gap-6">
        <div className="flex flex-col gap-1 min-w-0">
          <h1 className="text-heading-xl font-semibold text-ia-text truncate">{title}</h1>
          {description && (
            <p className="text-body-sm text-ia-text-secondary max-w-prose">{description}</p>
          )}
        </div>
        {actions && <div className="flex items-center gap-2 shrink-0">{actions}</div>}
      </div>
      {tabs && <div className="-mb-4">{tabs}</div>}
    </header>
  ),
)
PageHeader.displayName = 'PageHeader'
